import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { SaunaIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const AdjustableLoadElectricSaunaForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SAUNA>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<SaunaIcon />}
                content={
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Sauna
                        </p>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricSauna.value.installed}
                        {...getFieldProps("adjustableLoadElectricSauna.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.adjustableLoadElectricSauna.value.installed = checked;
                                values.adjustableLoadElectricSauna.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricSauna.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.adjustableLoadElectricSauna.value.demand.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricSauna.value.demand.unit}
                            value={values.adjustableLoadElectricSauna.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.adjustableLoadElectricSauna.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricSauna.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
